import type { ColumnDef } from "@tanstack/react-table";
import type { PeriodeGrade } from "../api/get-grade";

export const columns: ColumnDef<PeriodeGrade>[] = [
  {
    accessorKey: 'master_periode_id',
    header: 'ID Periode',
  },
  {
    accessorKey: 'grade',
    header: 'Grade',
  },
  {
    accessorKey: 'nilai_min',
    header: 'Nilai Minimum',
  },
  {
    accessorKey: 'nilai_max',
    header: 'Nilai Maksimum',
  },
];
